import { Injectable, inject } from "@angular/core";
import { Resolve } from "@angular/router";
import { EntryPageResource } from "core/stages-client";

type EntryPageTab = stages.entrypage.EntryPageTab;

@Injectable({ providedIn: "root" })
export class EntryPageTabsResolver implements Resolve<EntryPageTab[]> {
	private entryPageResource = inject(EntryPageResource);

	async resolve(): Promise<EntryPageTab[]> {
		return this.entryPageResource.getTabs();
	}
}
